module.exports = __webpack_public_path__ + "static/Vanta-60542aea83c8ea5004c63760239b8b7f.jpg";